import { useBrand } from '@bnnvara/brand';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import VideoCard from '../../components/cards/VideoCard';
import Link from '../../components/Link';

const ComposableVideoCard = (props) => {
  const brand = useBrand();
  const { id, index } = props;

  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 3"
      columnEndXl="span 3"
      key={id}
    >
      <Link
        href={`/videos/${id}`}
        category="Homepage"
        label={`video${index}`}
        action="click"
      >
        <VideoCard {...props} brand={brand} />
      </Link>
    </GridItem>
  );
};

ComposableVideoCard.propTypes = {
  id: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

export default ComposableVideoCard;
